let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9wB0S")).then(() => parcelRequire('64GVS'));